import CookieStorage from './CookieStorage';
import cookie from 'cookie';
import Gateway from '../Gateway';
import CounterState from './CounterState';

export default class SessionCounter extends CookieStorage {
  constructor() {
    super();
    const valueFromCookie = cookie.parse(Gateway.window.document.cookie)[this.key];
    this.data = valueFromCookie ? valueFromCookie : this._defaultValue;
  }

  get key() {
    return 'sa_session_counter'
  }

  get _defaultValue() {
    return 0;
  }

  get() {
    const currentValue = this.data;
    this.increase();
    return Number(currentValue);
  }

  increase() {
    if (!CounterState.wasUpdated()) {
      CounterState.lock();
      this.data = Number(this.data) + 1;
      this._save();
    }
  }
}
